import { StepperItem } from './StepperItem';
import { StepperRoot } from './StepperRoot';

export const Stepper = {
  Root: StepperRoot,
  Item: StepperItem,
};
